var _path, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCctv = function SvgCctv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M17.5 6v5.333c0 1.685-.825 3.48-2.198 4.862C13.932 17.572 12.056 18.5 10 18.5s-3.933-.928-5.302-2.305C3.325 14.814 2.5 13.018 2.5 11.333V6A1.5 1.5 0 0 1 4 4.5h12A1.5 1.5 0 0 1 17.5 6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    x: 6.5,
    y: 7.5,
    rx: 3.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    x: 6.5,
    y: 7.5,
    stroke: "currentColor",
    rx: 3.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 9.5,
    y: 10.5,
    fill: "#fff",
    rx: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 9.5,
    y: 10.5,
    stroke: "currentColor",
    rx: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 1,
    x: 2,
    y: 1,
    fill: "currentColor",
    rx: 0.5
  })));
};
export default SvgCctv;